import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/scss/bootstrap-custom.scss'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import axios from 'axios'
import { axiosCredentials } from '@/axios-credentials'
import VueCookies from 'vue-cookies'
import * as pdfjsLib from 'pdfjs-dist'

// PDF.js Worker設定
pdfjsLib.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`

// API Server baseURL設定
axios.defaults.baseURL = process.env.VUE_APP_API_ENDPOINT
axiosCredentials.defaults.baseURL = process.env.VUE_APP_API_ENDPOINT

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(VueCookies)
Vue.prototype.$axios = axios
Vue.prototype.$axiosCredentials = axiosCredentials

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
